module.exports = __webpack_public_path__ + "static/media/1021460.86097c49.jpg";